var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('font-awesome-icon',{style:(_vm.shown.style),attrs:{"icon":_vm.shown.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }